const testimonials = [
  {
    id: 1,
    name: "Anna Müller",
    course: "Beginner German",
    content: "Per's lessons are clear, fun, and easy to follow. I learned a lot in just a few weeks!"
  },
  {
    id: 2,
    name: "Lukas Schmidt",
    course: "Intermediate German",
    content: "I love the interactive exercises. They really helped me improve my speaking skills."
  },
  {
    id: 3,
    name: "Sophie Weber",
    course: "Advanced German",
    content: "The explanations are very detailed and practical. Highly recommend for serious learners!"
  },
  {
    id: 4,
    name: "Maximilian Bauer",
    course: "Beginner German",
    content: "The lessons are well-structured and the tips for real-life conversations are very useful."
  }
];

export default testimonials;
